import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import * as clipboard from 'clipboard-polyfill/dist/clipboard-polyfill.promise';
import { formatDate } from '@/mixins/format-date';
import { guid } from '@/mixins/guid';
import { getDomain } from 'tldjs';

export default Vue.component('transfer-domain', {
  template: require('./template.html'),
  name: 'transfer-domain',
  mixins: [formatDate, guid],
  computed: {
    ...mapGetters(['account', 'priceSource', 'currentUser', 'identityId']),
  },
  props: ['current-site', 'modal', 'toggle-modal'],
  data() {
    return {
      loading: false,
      newdomain: '',
      checkError: false,
      nameServers: [],
      existsError: false,
      checkRetry: 0,
      copies: {},
    };
  },
  methods: {
    async moveDomain() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          const newDomain = getDomain(this.newdomain);
          const name = newDomain.split('.')[0];
          let tld = newDomain.split('.').pop();
          tld = `.${tld}`;
          this.existsError = false;
          if (!this.domainExists(name, tld)) {
            this.loading = true;
            this.checkError = false;
            this.nameServers = [];
            const now = Date.now();
            const payload = {
              ref: now.toString(),
              domain: newDomain,
              date: this.formatDate(now),
              email: this.currentUser.email,
              site: this.currentSite._id,
              cloudFront: this.currentSite.cloudFront,
            };
            try {
              const data = await this._SEND([{
                name: 'transferDomain',
                payload,
              }]);
              const newAlias = data.record;
              const hostedZoneId = data.hostedZoneId;
              const nameServers = data.zone.DelegationSet.NameServers;

              // save to state
              if (newAlias) {
                this.$store.dispatch('addOwnedDomain', {
                  site: this.currentSite,
                  newDomain: {
                    _id: this.guid(),
                    name,
                    tld,
                    managed: true,
                    hostedZoneId,
                    nameServers,
                    records: [newAlias],
                    status: 'IN_PROGRESS',
                    planPrice: 0,
                  },
                });
              }
              await this._SEND([{
                name: 'updateSiteAttr',
                payload: {
                  siteId: this.currentSite._id,
                  attr: 'domains',
                  value: this.currentSite.domains,
                },
              }]);
              this.$log.debug('updateSiteAttr: domains');
              this.nameServers = nameServers;
              _.forEach(nameServers, (ns, i) => {
                this.$set(this.copies, i, false);
              });

              this.checkRetry = 0;
              // run the local recheck so we can turn off adding more domains
              this.$emit('recheck-domains-nested');
              // notify user
              this.$store.dispatch('addNotification', {
                id: this.guid(),
                type: 'success',
                message: `Successfully added domain name ${newDomain}!`,
              });
            } catch (e) {
              this.checkError = e;
              // known full table scan error
              if (e.message === 'Cannot read property \'push\' of undefined') {
                this.$log.warn(`${e} | Known issue. Trying again...`);
                this.checkRetry += 1;
                if (this.checkRetry < 11) {
                  this.moveDomain();
                } else {
                  this.checkError = 'There was a problem checking on this domain\'s availability. Please try again.';
                  this.checkRetry = 0;
                }
              } else {
                this.$log.error(e);
                await this._reportError({
                  error: e,
                  fn: 'moveDomain',
                });
              }
            } finally {
              this.loading = false;
              this._trackEvent({
                type: 'transfer_domain',
                meta: {
                  site_name: this.currentSite.name,
                  site_type: this.currentSite.type,
                  site_tier: this.currentSite.tier,
                  domain: newDomain,
                },
              });
            }
          } else {
            this.existsError = true;
          }
        }
      });
    },
    copyNameServer(ns, i) {
      clipboard.writeText(ns).then(() => {
        this.copies[i] = true;
        setTimeout(() => {
          this.copies[i] = false;
        }, 1500);
      });
    },
    domainExists(name, tld) {
      return _.find(this.currentSite.domains, { name, tld });
    },
    closeModal(type) {
      this.$emit('toggle-modal', type);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/domains/add-domain/owned/transfer/index.js